import $ from 'jquery';
class Products {
	constructor(element) {
		this.load();
		// $(document).ready(() => this.load());
	}
	load() {
		if($('.twz-element-products').length) {
			$(document).on("sf:ajaxfinish", ".searchandfilter", () => this.loadActiveTags());
			this.loadActiveTags();
			$(document).on('click','.sf-field-reset__tags a',(e) => this.resetTag(e))
		}
	}
	loadActiveTags() {
		$('.sf-field-reset').append('<div class="sf-field-reset__tags"></div>')
		this.hideOrShowResetWindow();
		var checkedinputs = $('.twz-element-products__filter input[type="checkbox"]:checked').each((index,el) => {
			$('.sf-field-reset__tags').append('<a class="btn btn--as-link btn--tag btn--close" data-tag="'+$(el).attr('id')+'">'+$(el).next().html()+'</a>');
		})
	}
	resetTag(e) {
		$('#'+$(e.currentTarget).data('tag')).trigger('click')
		this.hideOrShowResetWindow();
		$(e.currentTarget).remove();
	}
	hideOrShowResetWindow() {
		var checkedinputs = $('.twz-element-products__filter input[type="checkbox"]:checked');
		if(checkedinputs.length) {
			$('.sf-field-reset').show(0)
		} else {
			$('.sf-field-reset').hide(0)
		}
	}
}
new Products